import { render } from "./TrattativeComponent.vue?vue&type=template&id=73208fa5&scoped=true"
import script from "./TrattativeComponent.vue?vue&type=script&lang=js"
export * from "./TrattativeComponent.vue?vue&type=script&lang=js"

import "./TrattativeComponent.vue?vue&type=style&index=0&id=73208fa5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73208fa5"]])

export default __exports__